// Global ref for the footer's Template actions (WorkspaceMenus).
// Same pattern as symbolSpotlightRef / indicatorsPickerRef — lets the chart
// context menu trigger the SAME dialogs the footer "Template" button opens
// (they live inside WorkspaceMenus, which is always mounted in the footer).
export const workspaceTemplateRef = { current: null };
